import React, { Component } from "react";
import { Grid, IconButton, Typography } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

export default class HeaderBar extends Component {
    constructor() {
        super();
        this.state = {
            isMenuOpen: false
        }
    }

    previousDay = () => {

        var newDate = this.props.currentDate;
        newDate.setDate(newDate.getDate() - 1);

        this.changeDay(newDate);
    };

    nextDay = () => {

        var newDate = this.props.currentDate;
        newDate.setDate(newDate.getDate() + 1);

        this.changeDay(newDate);
    };

    changeDay = (selectedDate) => {
        this.props.onChangeDay(selectedDate);
    };

    render() {
        return (
            <div>
                <Grid
                    container
                    direction="row"
                    justify="space-between">
                    <Grid item xs="auto">
                        {this.props.currentDate &&
                            <Grid container item xs justify="flex-start" alignItems="center">
                                <Grid item xs="auto">
                                    <IconButton onClick={this.previousDay} size="small">
                                        <KeyboardArrowLeftIcon />
                                    </IconButton>
                                </Grid>
                                <Grid item xs="auto">
                                    <Typography variant="body1" className="center">{this.props.currentDate?.toDateString()}</Typography>
                                </Grid>
                                <Grid item xs="auto">
                                    <IconButton onClick={this.nextDay} size="small">
                                        <KeyboardArrowRightIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </Grid>
            </div>);
    }
}